// copied from lodash, https://github.com/lodash/lodash/blob/4.17.11/lodash.js#L16166

/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

let idCounter = 0;

export function uniqueId(prefix) {
	let id = ++idCounter;
	return String(prefix) + id;
}
